export class Filter {
    ids?: string;
}

export interface Options {
    embed?: string;
}

export interface Paging {
    pageNumber?: number;
    pageSize?: number;
    rpp?: number;
}

export interface Sorting {
    orderBy?: string;
    ascending?: boolean;
}